import React from 'react';
import { PEIRecordsInfo } from '../PEIRecordsInfo';
import styles from '@/styles/PEIScalableTable.module.scss';
import { PEIImage } from '../PEIImage';
import { useWindowSize, FlexibleTableProps, PEILink } from '@/common';
import { generatePathsOfAssets } from '@/utils';
import { useAppContext } from '@/components';

const breakPoint = 1024;

export const PEIScalableTable = ({
  title,
  headers,
  data,
  start,
  end,
  institutionName,
  componentName,
}: {
  title: string;
  headers: Array<string>;
  data: FlexibleTableProps;
  institutionName: string;
  start: number;
  end: number;
  componentName?: string;
}) => {
  const {
    state: { isECJest },
  } = useAppContext();
  const { width } = useWindowSize();
  return (
    <section className={styles.container}>
      <h3 className={styles.heading} data-testid='table-title-id'>
        {title}
      </h3>
      <section className={styles['table-container']}>
        <table className={styles.table} role='table'>
          <thead className={styles['row-header']}>
            <tr className={styles.row}>
              {React.Children.toArray(
                headers.map((title: string) => (
                  <th className={`${styles['cell-header']} ${styles['cell']} `}>{title}</th>
                ))
              )}
            </tr>
          </thead>
          <tbody>
            {React.Children.toArray(
              data.map(
                (row: Array<{ text: string }>): JSX.Element => (
                  <tr className={styles.row}>
                    {React.Children.toArray(
                      row.map(
                        (
                          { text, icon, link }: { text: string; icon?: string; link?: string },
                          index
                        ) => (
                          <td className={styles.cell}>
                            <div className={styles['data-container']}>
                              {!isECJest && index != 0 && (
                                <span className={styles['headers-in-mobile']}>
                                  {headers[index]}
                                </span>
                              )}
                              {icon && (
                                <span className={styles['icon-container']}>
                                  <PEIImage
                                    src={generatePathsOfAssets(icon)}
                                    alt={`${icon} image`}
                                    width={21.12}
                                    height={20}
                                    className={styles.icon}
                                  />
                                </span>
                              )}
                              <span className={icon === 'lock' ? styles.hide : ''}>
                                {link && icon !== 'lock' ? (
                                  <PEILink className={styles['text-link']} href={link}>
                                    {text}
                                  </PEILink>
                                ) : (
                                  text
                                )}

                                {index === 0 && icon === 'lock' && width <= breakPoint && (
                                  <span className={styles['extra-text']}> {headers[index]}</span>
                                )}
                              </span>
                            </div>
                          </td>
                        )
                      )
                    )}
                  </tr>
                )
              )
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={headers.length} className={styles['table-footer']}>
                <PEIRecordsInfo
                  start={start}
                  end={end}
                  institutionName={institutionName}
                  componentName={componentName}
                />
              </td>
            </tr>
          </tfoot>
        </table>
      </section>
    </section>
  );
};
